import React from "react";
import "./roadpic.css";

function Roadpic() {
  return (
    <div className="mainroadpic">
      <div className="subroadpic">
        <div className="roadmap44">
            <img className="roadclockpic" src="clock6.png" alt="" />  
          <img className="roadmap55" src="roadmap.png" alt="" />
        </div>
      </div>
    </div>
  );
}
export default Roadpic;
 